'use client';

//* Components
import HeroHome from '../Hero';

//* Modules
import FAQSection from '@/modules/_section/FAQSection';
import NewsSection from '@/modules/_section/NewsSection';
import ServiceSection from '@/modules/_section/ServiceSection';
import AboutUsSection from '@/modules/_section/AboutUsSection';
import WhyChooseUsSection from '@/modules/_section/WhyChooseUsSection';

//* Styles
import HomeTemplateStyle from './style';

const HomeTemplate = () => {
	return (
		<HomeTemplateStyle>
			<HeroHome />

			<AboutUsSection />

			<WhyChooseUsSection />

			<ServiceSection />

			{/* <NewsSection /> */}

			<FAQSection />
		</HomeTemplateStyle>
	);
};

export default HomeTemplate;
